"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const common_1 = require("@epic-core/common");
const Message_1 = require("../message/Message");
const window_or_global_1 = __importDefault(require("window-or-global"));
const GiftcardBannerStyled_1 = __importDefault(require("./GiftcardBannerStyled"));
const GiftcardBanner = ({ posaGiftCardRedeemUrl }) => {
    const onClick = () => {
        window_or_global_1.default.location.href = `${posaGiftCardRedeemUrl}?lang=${common_1.getLocale()}`;
    };
    return (react_1.default.createElement(GiftcardBannerStyled_1.default, { className: "giftcard-banner" },
        react_1.default.createElement("img", { className: "giftcard-image", alt: "giftcard", src: "https://cdn2.unrealengine.com/fn-giftcard-07b20928806c.svg" }),
        react_1.default.createElement("div", { className: "giftcard-callout row" },
            react_1.default.createElement("div", { className: "col-sm-8" },
                react_1.default.createElement("h2", null, Message_1.localizedMessage('epic.code.redemption.posa.giftcard.title'))),
            react_1.default.createElement("div", { className: "col-sm-4 redeem-btn" },
                react_1.default.createElement("button", { onClick: onClick, className: "btn btn-primary" }, Message_1.localizedMessage('epic.common.redeem'))))));
};
GiftcardBanner.propTypes = {
    posaGiftCardRedeemUrl: prop_types_1.default.string
};
exports.default = GiftcardBanner;
//# sourceMappingURL=GiftcardBanner.js.map